/**
 * Quantity selector component
 * 
 * @module quantity-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'quantity-selector';

 if(!customElements.get(customElements.component)) {
  
     class quantitySelector extends HTMLElement {
 
         /**
          * Quantity selector web component
          * 
          * @constructor
          */
         constructor() {
 
             super();
             
             this.classList.add('quantity-selector');
 
             this.input = this.querySelector('input');
 
             this.render();
         }
 
         render() {
 
             this.renderInput();
 
             let decreaseBtn = document.createElement('button');
             decreaseBtn.innerText = 'Decrease quantity';
             decreaseBtn.dataset.action = 'decrease';
             decreaseBtn.setAttribute('type', 'button');
             decreaseBtn.setAttribute('data-add-to-card-content', '');
             this.prepend(decreaseBtn);

             let increaseBtn = document.createElement('button');
             increaseBtn.innerText = 'Increase quantity';
             increaseBtn.dataset.action = 'increase';
             increaseBtn.setAttribute('type', 'button');
             increaseBtn.setAttribute('data-add-to-card-content', '');
             this.append(increaseBtn);
 
             this.initEvents();
         }
 
         renderInput() {
 
             if (!this.input) {
 
                 let input           = document.createElement('input');
                 input.type          = 'number';
                 input.min           = 1;
                 input.size          = 4;
                 input.autocomplete  = 'off';
                 input.pattern       = '[0-9]*';
                 input.name          = (this.dataset.name) ? this.dataset.name : '';
                 input.id            = (this.dataset.id) ? this.dataset.id : '';
                 input.value         = (this.dataset.value) ? parseInt(this.dataset.value) : 1;
                 input.ariaLabel     = (this.dataset.label) ? this.dataset.label : 'Quantity';
 
                 this.prepend(input);
 
                 this.input = this.querySelector('input');
             }
         }
 
         initEvents() {
 
             this.querySelector('[data-action="decrease"]').addEventListener('click', this.decrease.bind(this));
             this.querySelector('[data-action="increase"]').addEventListener('click', this.increase.bind(this));
         }
 
         decrease() {
 
             let value = parseInt(this.input.value);
 
             if (value > 0) {
 
                 value--;
 
                 this.input.value = value;
 
                 let event = new CustomEvent('change', {'detail': this.input });
 
                 this.input.dispatchEvent(event);
             }
         }
 
         increase() {
            let value = parseInt(this.input.value);
            let maxValue = parseInt(this.input.max);

            if (maxValue > 0) {
                if (value + 1 > maxValue) {
                    alert('You cannot add more than ' + maxValue + ' items to the cart.');
                    return;
                }
            }
 
            value++;
            this.input.value = value;
            let event = new CustomEvent('change', {'detail': this.input });     
            this.input.dispatchEvent(event);
         }
     }
  
     customElements.define(customElements.component, quantitySelector);
 }
  